import React from 'react';
import { Input } from 'antd';
import { I18n } from '@aws-amplify/core';
import * as S from '@/components/Settings/DataExtraction/styles';

export function NameFormItem() {
	return (
		<S.CustomFormItem
			label={I18n.get('Name')}
			name={['general_information', 'name']}
			labelCol={{ span: 24 }}
			rules={[{ required: true, message: I18n.get('Name is required') }]}
		>
			<Input placeholder={I18n.get('Name')} />
		</S.CustomFormItem>
	);
}
